// @flow
import Actions from 'esm-web-pro/components/layout/sidePanel/Actions';
import { Box } from 'grommet';
import * as React from 'react';

type Props = {
    actions: Array<Object>,
    pad?: Object | string,
    width?: string,
    actionsProps?: React.ElementConfig<typeof Actions>,
};

const RowActions = (props: Props) => {
    const {
        actions, pad, width, actionsProps,
    } = props;
    return (
        <Box
            width={width}
            align="center"
            direction="row"
            pad={pad}
            justify="end"
            gap="small"
            focusable={false}
        >
            <Actions
                iconPadding="3px"
                actions={actions}
                {...actionsProps}
            />
        </Box>
    );
};

RowActions.defaultProps = {
    pad: { right: '15px' },
    width: '100%',
    actionsProps: {},
};

export default RowActions;
